import ApiService from './service';
import * as http from './http';

export class ActiveEmployeeService extends ApiService {

    async getAllActiveEmployees(request) {
        const { resource, ...params } = request;

        const url = `${this.apiDomain}${resource ? `/${resource}` : ''}`;
        try {
            const response = await http.get(url, this.store, { params });
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching active employees:", error);
            return { data: [] };
        }
    }



    async getActiveEmployeeById(request) {
        const url = `${this.apiDomain}/api/${request.resource}`;
        try {
            const response = await http.get(url, this.store);
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching employee by ID:", error);
            return { data: null };
        }
    }

    async postActiveEmployee(request, data) {
        const url = `${this.apiDomain}/api/${request.resource}`;
        try {
            const response = await http.post(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [POST] Error creating employee:", error);
            return null;
        }
    }

    async updateActiveEmployee(request, data) {
        const url = `${this.apiDomain}/api/${request.resource}`;
        try {
            const response = await http.put(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PUT] Error updating employee:", error);
            return null;
        }
    }

    async deleteActiveEmployee(request) {
        const url = `${this.apiDomain}/api/${request.resource}`;
        try {
            const response = await http.remove(url, this.store);
            return response;
        } catch (error) {
            console.error("❌ [DELETE] Error deleting employee:", error);
            return null;
        }
    }

    async softDeleteActiveEmployee(request) {
        const url = `${this.apiDomain}/api/${request.resource}`;
        try {
            const response = await http.patch(url, {}, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PATCH] Error soft deleting employee:", error);
            return null;
        }
    }
}
